import { render, staticRenderFns } from "./list-person.vue?vue&type=template&id=1fd8f64c&scoped=true"
import script from "./list-person.vue?vue&type=script&lang=js"
export * from "./list-person.vue?vue&type=script&lang=js"
import style0 from "./list-person.vue?vue&type=style&index=0&id=1fd8f64c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd8f64c",
  null
  
)

export default component.exports